import Model, { attr } from '@ember-data/model';

export default class IntegrationLogBase extends Model {
  @attr('string') _id;
  @attr('string') Message;
  @attr('number') Severity;
  @attr('date') CreatedDateTime;
  @attr ExtensionAttributes;
}
